/* eslint-disable react/no-danger */
import BlockRelevanceBadge from 'components/atoms/block_relevance_badge';
import React from 'react';
import { ExpanderComponentProps } from 'react-data-table-component';

interface DataTableItem {
  id: number;
  theme: string;
  objective: string;
  block_text: string;
  relevance: number;
}
interface BlockInventoryType {
  id: number;
  block_objective: string;
  block_reference: string;
  block_related_words: string;
  block_text: string;
  block_text_words_list: string;
  document_type_id: number;
  law_type_id: number;
  proc_text: string;
  status: string;
  title: string;
}
interface BlockType {
  block_inventory: BlockInventoryType;
  from_keywords: boolean;
  sim_percent: number;
}

const TITLE_GROW = 3;
const THEME_GROW = 1;
const RELEVANCE_GROW = 2;

export const datatableData = (blockList: Array<BlockType>): Array<DataTableItem> => {
  return blockList?.map((block) => {
    return {
      id: block.block_inventory.id,
      theme: block.block_inventory.title,
      objective: block.block_inventory.block_objective,
      block_text: block.block_inventory.block_text,
      relevance: block.sim_percent,
    };
  });
};

export const expandedComponent: React.FC<ExpanderComponentProps<DataTableItem>> = ({ data }) => {
  return <p dangerouslySetInnerHTML={{ __html: data.block_text }} />;
};

export const datatableColumns = (
  checkOrUncheckBox: (id: number) => void,
  checkedBlocks: Array<number>,
  setSelectedRows: React.Dispatch<React.SetStateAction<number[]>>,
  selectedRows: number[],
) => {
  return [
    {
      name: '',
      width: '100px',
      center: true,
      allowOverflow: true,
      grow: TITLE_GROW,
      cell: (data: DataTableItem) => (
        <input
          type="checkbox"
          checked={checkedBlocks.includes(data.id)}
          onChange={(event) => {
            if (event.target.checked) {
              checkOrUncheckBox(data.id);
              setSelectedRows([...selectedRows, data.id]);
            } else {
              checkOrUncheckBox(data.id);
              setSelectedRows(selectedRows.filter((rowId) => rowId !== data.id));
            }
          }}
        />
      ),
    },
    {
      name: 'Tema',
      sortable: true,
      selector: (data: DataTableItem) => data.theme,
      ignoreRowClick: true,
      grow: THEME_GROW,
      cell: (data: DataTableItem) => (
        <div className="mt-2">
          <strong style={{ fontSize: '16px', color: '#495057' }}>{data.theme}</strong>
          <br />
          <p className="mt-2" style={{ fontSize: '14px', color: '#495057' }}>
            <span className="text-primary">Objetivo: </span>
            {data.objective}
          </p>
        </div>
      ),
    },
    {
      name: 'Relevância',
      width: '220px',
      sortable: true,
      grow: RELEVANCE_GROW,
      center: true,
      selector: (data: DataTableItem) => data.relevance,
      cell: (data: DataTableItem) => <BlockRelevanceBadge relevance={data.relevance} />,
    },
  ];
};
